import scss from "./TableScrollHint.module.scss";

const TableScrollHint = () => (
    <div className={scss.hint}>
        <span className={scss.icon} aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
                <path d="M3.5 12h17M8 7.5 3.5 12 8 16.5M16 7.5l4.5 4.5-4.5 4.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </span>
        <span>Prevucite tabelu u levo za ostale kolone</span>
    </div>
);

export default TableScrollHint;
